export default __webpack_public_path__ + "static/media/pvpgameicon.0dc561f9.png";